
import packageInfo from "../../package.json"; 
import { getDynamicConfigValue } from "../dynamicConfig";

const getAppName = () => getDynamicConfigValue("REACT_APP_TRACKING_APP_NAME");

export const track = (eventName, eventParams) => {
    eventParams = eventParams || {};
    eventParams = { 
        ...eventParams, 
        appName: getAppName(),
        version: packageInfo.version
      }
    window.analytics.track(`${eventName}`, eventParams);
}

export const identify = (eventName, id, eventParams) => {
  eventParams = eventParams || {};
  eventParams = { 
      ...eventParams, 
      appName: getAppName(),
      version: packageInfo.version
    }
  window.analytics.identify(id, eventParams);
}